<template>
  <NuxtLayout>
    <div class="slot-body">
      <div class="container">
        <div class="column pt-5 align-items-center justify-content-center">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <span class="title"> Error {{ props.error?.statusCode }}! </span>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-center">
            <span class="subtitle">
              {{
                props.error?.statusCode === 404
                  ? tanslate.subtitle
                  : props.error?.message
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
const props = defineProps<{ error: NuxtError }>();
const route = useRoute();
const tanslate = computed(() =>
  route.fullPath.includes("/pt-br/") ? tradutores.portugues : tradutores.ingles
);

useHead({
  title: props.error?.statusCode === 404 ? "Error 404" : "Error",
  templateParams: {
    title: props.error?.statusCode === 404 ? "Error 404" : "Error",
    subTitle: "Error " + props.error?.statusCode,
    subPage:
      props.error?.statusCode === 404 ? "Página não encontrada!" : "",
  },
});

const tradutores = {
  portugues: {
    title: "Erro 404",
    subtitle: "Página não encontrada!",
  },
  ingles: {
    title: "Error 404",
    subtitle: "Page not found!",
  },
};
</script>
<style scoped lang="css">
.slot-body {
  margin-top: 65px !important;
  background-color: #fff !important;
  height: 50vh;
}

.title {
  font-family: "Bebas-Neue-Light";
  height: 77px;
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.subtitle {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 769px) {
  .title {
    font-family: "Bebas-Neue-Light";
    height: 77px;
    color: #000000;
    font-size: 44px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
  }
}
</style>
